// extracted by css-extract-rspack-plugin
export default {"clearButton":"CeCJi9kYI4UpicCw","icon":"YA0ez3ad1l8LO2X5"};